import { h } from 'preact';

export function CheckboxEntry({ id, label, checked, onChange, disabled = false, description }) {
  return (
    <div class="epx-entry epx-checkbox">
      <label class="epx-entry-label epx-checkbox-label" htmlFor={id}>
        <input
          id={id}
          type="checkbox"
          class="epx-entry-checkbox"
          checked={!!checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
        />
        {label}
      </label>
      {description && <div class="epx-entry-description">{description}</div>}
    </div>
  );
}
